import React, { useState } from 'react';
import { Button, Modal, Tooltip } from 'antd';
import AddNewWebsiteIndexEntry from './AddNewWebsiteIndexEntry';


type Props = {
    label?: string;
};


export default function AddNewWebsiteIndexEntryButton({ label }: Props) {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const toggleModal = () => {
        setIsModalVisible(!isModalVisible);
    };

    return (
        <div>
            <Tooltip placement="topRight" title="Track new website">
                <Button type="primary" icon="plus" onClick={toggleModal}>
                    {label ? label : null}
                </Button>
            </Tooltip>

            <Modal
                className="new-website-wizard-modal"
                visible={isModalVisible}
                title="Add new website"
                footer={null}
                onCancel={toggleModal}
                destroyOnClose={true}
                maskClosable={false}
                width={"768px"}
            >
                <div className="form-container">
                    <AddNewWebsiteIndexEntry fromOnboarding={false} onFinish={toggleModal} />
                </div>

            </Modal>
        </div>
    );
}
